export const LISTINGS_PAGE_TAGS = [
  'getListingProperties',
  'getListingPropertyUnits',
  'getListingUnitsList',
  'getListingOptions',
] as const;

export const MULTIPLEX_MUTATION_INVALIDATES = [
  'getProperties',
  'getPropertyTableUnits',
  'getMultiplexUnits',
  ...LISTINGS_PAGE_TAGS,
] as const;
